/*=========================================================================================
  File Name: moduleEcommerceState.js
  Description: Ecommerce Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

/* eslint-disable */
export default {
  cartItems: [
    { "name": "App", "description": "1 Mês", "setupFee": 119, "fixedPrice": 59.99, "quantity": 1, "intervalCount": 1, "intervalUnit": "MONTH", recurring: true }
  ],
  wishList: []
}
/* eslint-enable */
